import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const token = inject(TokenStorageService).getAccessToken();

  if (token) {
    const cloned = req.clone({
      setHeaders: { 'x-authentication-token': token },
    });
    return next(cloned);
  }

  return next(req);
};
